import React from "react";
import {
  FormField,
  FormInput,
  FormTextarea,
  Modal,
  ModalFooterButtons,
} from "../../../../components/Modal";

export interface AddRoleDialogProps {
  open: boolean;
  onClose: () => void;
  handleAddRole: () => void;
  addingRole: boolean;
  roleForm: {
    roleId: string;
    title: string;
    shortName: string;
    description: string;
  };
  setRoleForm: React.Dispatch<
    React.SetStateAction<{
      roleId: string;
      title: string;
      shortName: string;
      description: string;
    }>
  >;
}

export function AddRoleDialog({
  open,
  onClose,
  handleAddRole,
  addingRole,
  roleForm,
  setRoleForm,
}: AddRoleDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Add Role"
      description="Define a role for this SSP's metadata"
      size="sm"
      footer={
        <ModalFooterButtons
          onCancel={onClose}
          onSubmit={handleAddRole}
          submitLabel={addingRole ? "Saving" : "Save"}
          submitDisabled={!roleForm.roleId || !roleForm.title || addingRole}
        />
      }
    >
      <div className="grid grid-cols-2 gap-3">
        <FormField label="Role ID" required hint="Machine identifier">
          <FormInput
            placeholder="e.g. isso"
            value={roleForm.roleId}
            onChange={(v) => setRoleForm((f) => ({ ...f, roleId: v }))}
          />
        </FormField>
        <FormField label="Title" required>
          <FormInput
            placeholder="e.g. Information System Security Officer"
            value={roleForm.title}
            onChange={(v) => setRoleForm((f) => ({ ...f, title: v }))}
          />
        </FormField>
      </div>
      <FormField label="Short Name">
        <FormInput
          placeholder="e.g. ISSO"
          value={roleForm.shortName}
          onChange={(v) => setRoleForm((f) => ({ ...f, shortName: v }))}
        />
      </FormField>
      <FormField label="Description">
        <FormTextarea
          placeholder="Role description"
          value={roleForm.description}
          onChange={(v) => setRoleForm((f) => ({ ...f, description: v }))}
          rows={2}
        />
      </FormField>
    </Modal>
  );
}
